/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

export const builtinFunctions = [
  { label: 'AVG', description: null },
  { label: 'BIT_AND', description: null },
  { label: 'BIT_OR', description: null },
  { label: 'BOOL_AND', description: null },
  { label: 'BOOL_OR', description: null },
  { label: 'COUNT', description: null },
  { label: 'MAX', description: null },
  { label: 'MIN', description: null },
  { label: 'SUM', description: null },
  { label: 'SELECTIVITY', description: null },
  { label: 'STDDEV_POP', description: null },
  { label: 'STDDEV_SAMP', description: null },
  { label: 'VAR_POP', description: null },
  { label: 'VAR_SAMP', description: null },
  { label: 'ABS', description: null },
  { label: 'ACOS', description: null },
  { label: 'ASIN', description: null },
  { label: 'ATAN', description: null },
  { label: 'COS', description: null },
  { label: 'COSH', description: null },
  { label: 'COT', description: null },
  { label: 'SIN', description: null },
  { label: 'SINH', description: null },
  { label: 'TAN', description: null },
  { label: 'TANH', description: null },
  { label: 'ATAN2', description: null },
  { label: 'BITAND', description: null },
  { label: 'BITGET', description: null },
  { label: 'BITOR', description: null },
  { label: 'BITXOR', description: null },
  { label: 'MOD', description: null },
  { label: 'CEILING', description: null },
  { label: 'DEGREES', description: null },
  { label: 'EXP', description: null },
  { label: 'FLOOR', description: null },
  { label: 'LOG', description: null },
  { label: 'LOG10', description: null },
  { label: 'RADIANS', description: null },
  { label: 'SQRT', description: null },
  { label: 'PI', description: null },
  { label: 'POWER', description: null },
  { label: 'RAND', description: null },
  { label: 'RANDOM_UUID', description: null },
  { label: 'ROUND', description: null },
  { label: 'ROUNDMAGIC', description: null },
  { label: 'SECURE_RAND', description: null },
  { label: 'SIGN', description: null },
  { label: 'ENCRYPT', description: null },
  { label: 'DECRYPT', description: null },
  { label: 'TRUNCATE', description: null },
  { label: 'COMPRESS', description: null },
  { label: 'EXPAND', description: null },
  { label: 'ZERO', description: null },
  { label: 'ASCII', description: null },
  { label: 'BIT_LENGTH', description: null },
  { label: 'LENGTH', description: null },
  { label: 'OCTET_LENGTH', description: null },
  { label: 'CHAR', description: null },
  { label: 'CONCAT', description: null },
  { label: 'CONCAT_WS', description: null },
  { label: 'DIFFERENCE', description: null },
  { label: 'HEXTORAW', description: null },
  { label: 'RAWTOHEX', description: null },
  { label: 'INSTR', description: null },
  { label: 'INSERT', description: null },
  { label: 'LOWER', description: null },
  { label: 'UPPER', description: null },
  { label: 'LEFT', description: null },
  { label: 'RIGHT', description: null },
  { label: 'LOCATE', description: null },
  { label: 'POSITION', description: null },
  { label: 'LPAD', description: null },
  { label: 'RPAD', description: null },
  { label: 'LTRIM', description: null },
  { label: 'RTRIM', description: null },
  { label: 'TRIM', description: null },
  { label: 'REGEXP_REPLACE', description: null },
  { label: 'REGEXP_LIKE', description: null },
  { label: 'REPEAT', description: null },
  { label: 'REPLACE', description: null },
  { label: 'SOUNDEX', description: null },
  { label: 'SPACE', description: null },
  { label: 'STRINGDECODE', description: null },
  { label: 'STRINGENCODE', description: null },
  { label: 'STRINGTOUTF8', description: null },
  { label: 'SUBSTRING', description: null },
  { label: 'UTF8TOSTRING', description: null },
  { label: 'XMLATTR', description: null },
  { label: 'XMLNODE', description: null },
  { label: 'XMLCOMMENT', description: null },
  { label: 'XMLCDATA', description: null },
  { label: 'XMLSTARTDOC', description: null },
  { label: 'XMLTEXT', description: null },
  { label: 'TO_CHAR', description: null },
  { label: 'TRANSLATE', description: null },
  { label: 'CURRENT_DATE', description: null },
  { label: 'CURRENT_TIME', description: null },
  { label: 'CURRENT_TIMESTAMP', description: null },
  { label: 'DATEADD', description: null },
  { label: 'DATEDIFF', description: null },
  { label: 'DAYNAME', description: null },
  { label: 'DAY_OF_MONTH', description: null },
  { label: 'DAY_OF_WEEK', description: null },
  { label: 'DAY_OF_YEAR', description: null },
  { label: 'EXTRACT', description: null },
  { label: 'FORMATDATETIME', description: null },
  { label: 'HOUR', description: null },
  { label: 'MINUTE', description: null },
  { label: 'MONTH', description: null },
  { label: 'MONTHNAME', description: null },
  { label: 'PARSEDATETIME', description: null },
  { label: 'QUARTER', description: null },
  { label: 'SECOND', description: null },
  { label: 'WEEK', description: null },
  { label: 'YEAR', description: null },
  { label: 'COALESCE', description: null },
  { label: 'DECODE', description: null },
  { label: 'GREATEST', description: null },
  { label: 'IFNULL', description: null },
  { label: 'LEAST', description: null },
  { label: 'NULLIF', description: null },
  { label: 'NVL2', description: null },
  { label: 'CASEWHEN', description: null },
  { label: 'CAST', description: null },
  { label: 'CONVERT', description: null },
  { label: 'TABLE', description: null },
];
